var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import keys from '@debbie/common/dist/cache/keys';
import { ErrorYouAreAboutToMakePossibleUnintendedAdjustments, VoucherCategory, } from '@debbie/common/dist/economy/vouchers';
import * as caseVouchersAPI from '@debbie/cortex/dist/api/case-vouchers';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers';
import q from '@debbie/cortex/dist/query';
import THEME from '../../../theme';
import Back from '../../Back';
import Errors from '../../Errors';
import CostVoucherCreator from './CostVoucherCreator';
import CourtCostVoucherCreator from './CourtCostVoucherCreator';
import InterestVoucherCreator from './InterestVoucherCreator';
import PrincipalVoucherCreator from './PrincipalVoucherCreator';
import TransactionVoucherCreator from './TransactionVoucherCreator';
const VoucherCreator = (props) => {
    const lang = useSelector((s) => s.lang);
    const [error, setError] = useState(null);
    const createVoucher = (newCaseVoucher) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const caseVoucher = Object.assign(Object.assign({}, newCaseVoucher), { currency: props.singleCase.currency, caseId: props.caseId, referenceCaseVouchers: newCaseVoucher.referenceCaseVouchers &&
                    newCaseVoucher.referenceCaseVouchers.map((caseVoucher) => (Object.assign(Object.assign({}, caseVoucher), { currency: props.singleCase.currency, caseId: props.caseId }))) });
            const add = (preventAdjustments) => caseVouchersAPI.create(props.caseId, caseVoucher, {
                preventAdjustments: preventAdjustments,
            });
            try {
                yield add(true);
            }
            catch (error) {
                console.log('error test', error);
                if (
                // @ts-ignore
                ((_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.indexOf(ErrorYouAreAboutToMakePossibleUnintendedAdjustments)) !== -1) {
                    if (confirm(lang.billing.warnThisWillAffectBilling)) {
                        yield add(false);
                    }
                }
                else {
                    throw error;
                }
            }
            props.onCreate();
            q.invalidate(keys.write.create(caseVouchersEntity));
        }
        catch (err) {
            console.error(err);
            setError('Error: ' + err && err.errors);
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Back, { onClick: props.onBack, header: props.header ||
                lang.economyVoucherTypeLabels[props.voucherType.voucherTypeId] }),
        React.createElement(Wrapper, null,
            error && React.createElement(Errors, { errors: [error] }),
            (() => {
                switch (props.voucherType.category) {
                    case VoucherCategory.COST:
                        return (React.createElement(CostVoucherCreator, { caseId: props.caseId, voucherTypeId: props.voucherType.voucherTypeId, onCreate: createVoucher, defaultImposedByCreditor: props.defaultImposedByCreditor }));
                    case VoucherCategory.COURTCOST:
                        return (React.createElement(CourtCostVoucherCreator, { caseId: props.caseId, voucherTypeId: props.voucherType.voucherTypeId, onCreate: createVoucher }));
                    case VoucherCategory.INTEREST:
                        return (React.createElement(InterestVoucherCreator, { caseId: props.caseId, voucherTypeId: props.voucherType.voucherTypeId, onCreate: createVoucher, caseVouchers: props.caseVouchers }));
                    case VoucherCategory.PRINCIPAL:
                        return (React.createElement(PrincipalVoucherCreator, { caseId: props.caseId, voucherTypeId: props.voucherType.voucherTypeId, onCreate: createVoucher, caseVouchers: props.caseVouchers }));
                    case VoucherCategory.TRANSACTION:
                        return (React.createElement(TransactionVoucherCreator, { caseId: props.caseId, creditorId: props.creditorId, voucherTypeId: props.voucherType.voucherTypeId, onCreate: createVoucher }));
                    default:
                        return React.createElement("p", null, lang.economy.voucherCreationNotSupported);
                }
            })())));
};
export default VoucherCreator;
const Wrapper = styled.div `
  padding: ${THEME.GRID_SPACING}px;
  width: 400px;
`;
//# sourceMappingURL=VoucherCreator.js.map